import {createAsyncThunk} from '@reduxjs/toolkit';
import {AxiosResponse, AxiosInstance} from 'axios';
//enum
import {ACTION_TYPE} from '../actions-types';
//helpers
import {getErrorResponse} from '@/utils/helpers';
import {INotificationFilters, INotificationResData} from '@/utils/types';
import {NotificationService} from '@/utils/services/notification.service';

export const getAllNotifications = createAsyncThunk(
	ACTION_TYPE.NOTIFICATION_LIST,
	async ({data, apiInstance}: {data: INotificationFilters; apiInstance: AxiosInstance}, {rejectWithValue}) => {
		try {
			const organizationResponse: AxiosResponse<INotificationResData> = await NotificationService.getAllNotifications(
				data,
				apiInstance
			);

			return {
			...organizationResponse.data,
			target: (data.isRead === false ? 'unread' : 'all') as 'unread' | 'all',
		};
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);


// export const updateAllNotificationStatus = createAsyncThunk(
// 	ACTION_TYPE.NOTIFICATION_UPDATE_STATUS,
// 	async (id: string, {rejectWithValue}) => {
// 		try {
// 			// const organizationResponse: AxiosResponse<void> = await NotificationService.updateNotificationsStatus(id);
// 			// return organizationResponse.data;
// 		} catch (error) {
// 			return rejectWithValue(getErrorResponse(error));
// 		}
// 	}
// );

// export const updateNotificationStatus = createAsyncThunk(
// 	ACTION_TYPE.NOTIFICATION_UPDATE_STATUS,
// 	async (id: string, {rejectWithValue}) => {
// 		try {
// 			// const organizationResponse: AxiosResponse<void> = await NotificationService.updateNotificationsStatus(id);
// 			// return organizationResponse.data;
// 		} catch (error) {
// 			return rejectWithValue(getErrorResponse(error));
// 		}
// 	}
// );
